import TooltipPortal from '@ui/tooltip-portal/tooltip-portal';
import Text from '@ui/text/text/text';
import { ICONS } from '@ui/icons/types';
import InPersonAttendeeModeToggle from './in-person-attendee-mode-toggle';
import Icon from '@ui/icons/icon';
import DisableNativeRegistrationToggle from './disable-native-registration-toggle';
import RegistrationLimitToggle from './registration-limit-toggle';
import MarketingOptInToggle from './marketing-opt-in-toggle';
import useComputedRegistrationSettings from '../../hooks/use-computed-registration-settings';
import SettingsToggle from '../../../../controls/settings-toggle';
import { Registration } from '@/types/registration.types';
import { saveWorkingProjectByFields } from '@/store/slices/project';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { selectIsSavingWorkingProject } from '@/store/slices/project/selectors';
import styles from '../../registration-settings.module.css';

export default function AdvancedRegistrationSettings() {
  const { registrationSettings } = useComputedRegistrationSettings();
  const savingWorkingProject = useAppSelector(selectIsSavingWorkingProject);
  const dispatch = useAppDispatch();

  const toggleFeature = (value: string, on: boolean) => {
    if (!registrationSettings) return;
    const updatedSettings: Registration = {
      ...registrationSettings,
      [value as keyof Registration]: on,
    };
    dispatch(saveWorkingProjectByFields({ registration_settings: updatedSettings }));
  };

  return (
    <div className={styles.registrationSettingsSection}>
      <div className="flex ai-center gap-8">
        <Text tag="h5" className="h5">
          Advanced
        </Text>
        <TooltipPortal tooltipContent={<Text>Advanced Registration Settings</Text>}>
          <Icon name={ICONS.INFO_CIRCLE} size={12} color="var(--primitives-mode-1-gray-500)" />
        </TooltipPortal>
      </div>
      <InPersonAttendeeModeToggle />
      <SettingsToggle
        label="Recaptcha"
        loading={savingWorkingProject || !registrationSettings}
        value={registrationSettings?.enableRecaptcha || false}
        sKey="enableRecaptcha"
        onToggle={toggleFeature}
      />
      <DisableNativeRegistrationToggle />
      <RegistrationLimitToggle />
      <MarketingOptInToggle />
      <SettingsToggle
        label="Close registration"
        loading={savingWorkingProject || !registrationSettings}
        value={registrationSettings?.isClosed || false}
        sKey="isClosed"
        onToggle={toggleFeature}
      />
      <SettingsToggle
        label="Display speakers"
        loading={savingWorkingProject || !registrationSettings}
        value={registrationSettings?.enableSpeakers || false}
        sKey="enableSpeakers"
        onToggle={toggleFeature}
      />
      <SettingsToggle
        label="Overview content"
        loading={savingWorkingProject || !registrationSettings}
        value={registrationSettings?.enableOverviewContent || false}
        sKey="enableOverviewContent"
        onToggle={toggleFeature}
      />
    </div>
  );
}
